import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { GetSession, RemoveSession } from "./EnvConfig/env_config";
import BlurLoader from "./components/CommonComponents/BlurFullPageLoader";
import { ApiCall } from "./components/CommonComponents/CustomHooks";
import Header from "./components/Layout/Header";
import Sidebar from "./components/Layout/Sidebar";

const Protected = (Props) => {
    const { Component, PageUrl } = Props;
    const navigate = useNavigate();
    const [auth, setAuth] = useState(false)
    const subLoading = useSelector(state => state.auth.loading)
    const { open } = useSelector((state) => state.header);

    const checkLogin = async () => {
        const Token = await GetSession('cookies', 'token');
        let LoginUserCode = await GetSession('cookies', 'loginUserCode');

        if (!Token || Token === 'EXPIRED') {
            RemoveSession('cookies', 'token')
            RemoveSession('cookies', 'loginUserCode')
            RemoveSession('cookies', 'userName')
            navigate('/login');
        } else {
            if (typeof LoginUserCode !== 'string') {
                LoginUserCode = String(LoginUserCode);
            }
            const data = {
                Token: Token,
                LoginUserCode: LoginUserCode,
                PageUrl: PageUrl,
            };
            let res = await ApiCall(`/api/User/ValidateUserPageAccess`, data)
            if (res.status === "SUCCESS") {
                setAuth(true);
                document.title = res.menuText;
            } else {
                RemoveSession('cookies', 'token')
                RemoveSession('cookies', 'loginUserCode')
                RemoveSession('cookies', 'userName')
                navigate('/login');
            }
        }
    };



    useEffect(() => {
        checkLogin();
    }, [])

    return auth ? (
        <>
            {subLoading && <BlurLoader />}
            {PageUrl !== 'PasswordChangeRequest' && PageUrl !== 'InvoicePrintData' && PageUrl !== 'PartnerLedgerPrintData' &&
                <>
                    <Header />
                    <Sidebar />
                </>
            }
            <main
                {...(PageUrl !== 'PasswordChangeRequest' && PageUrl !== 'InvoicePrintData' && PageUrl !== 'PartnerLedgerPrintData' ? { id: "main", className: "main" } : {})}
                style={open ? {} : { marginLeft: "0" }}
            >
                <Component />
            </main>

        </>
    ) : <></>
}
export default Protected;